<template>
<table class="OTtable OTtableCompressed">
    <thead>
        <th class="OTborder-right">
            Info
        </th>
    </thead>
    <tbody>
        <tr v-for="componentId in cluster.components">
            <td>
                {{components[componentId].name}}
            </td>
        </tr>
    </tbody>
</table>
</template>

<script>

import componentTableMixin from  '../mixins/componentsTable.js';

export default {

    mixins: [componentTableMixin],

    computed: {
        components() {
            return this.$store.state.components.components;
        },

        cluster() {
            return this.$store.state.components.clusters[this.clusterId];
        }
    },

}
</script>
